export default "__VITE_ASSET__D2$f99xt__"